import { crowdsaleActionTypes } from './Types';

const INITIALSTATE = {
  popularcrowdsale: null,
  recommendcrowdsale: null,
  livecrowdsale: null,
  livecrowdfund: null,
  successfulcrowdsale: null,
  finalizedcrowdsale: [],
  finalizedcrowdfund: [],
  popularcrowdsaleloading: false,
  recommendcrowdsaleloading: false,
  liveprice: null,
  livecrowdsaleloading: false,
  livecrowdfundloading: false,
  successfulcrowdsaleloading: false,
  finalizedcrowdsaleloading: false,
  recentcrowdsale: null,
  recentcrowdsaleloading: false,
  cartdata: null,
  investloading: false,
};

const toFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const applyInvestmentToCollection = (
  collection,
  crowdsaleId,
  xlmIncrement,
  usdIncrement
) => {
  if (!collection || !Array.isArray(collection.data) || !crowdsaleId) {
    return collection;
  }

  return {
    ...collection,
    data: collection.data.map((item) => {
      if (String(item?._id) !== String(crowdsaleId)) {
        return item;
      }

      return {
        ...item,
        xlmRaised: toFiniteNumber(item?.xlmRaised) + xlmIncrement,
        usdCoinsRaised: toFiniteNumber(item?.usdCoinsRaised) + usdIncrement,
      };
    }),
  };
};

export const crowdsaleReducer = (state = INITIALSTATE, action) => {
  switch (action.type) {
    case crowdsaleActionTypes.POPULAR_CROWDSALE_START:
      return {
        ...state,
        popularcrowdsaleloading: true,
        popularcrowdsaleError: false,
      };
    case crowdsaleActionTypes.POPULAR_CROWDSALE_SUCCESS:
      return {
        ...state,
        popularcrowdsale: action.payload,
        popularcrowdsaleloading: false,
      };

    case crowdsaleActionTypes.RECOMMEND_CROWDSALE_START:
      return {
        ...state,
        recommendcrowdsaleloading: true,
        recommendcrowdsaleError: false,
      };
    case crowdsaleActionTypes.RECOMMEND_CROWDSALE_SUCCESS:
      return {
        ...state,
        recommendcrowdsale: action.payload,
        recommendcrowdsaleloading: false,
      };
    case crowdsaleActionTypes.LIVE_CROWDFUND_START:
      return {
        ...state,
        livecrowdfundloading: true,
        livecrowdfundError: false,
      };
    case crowdsaleActionTypes.LIVE_CROWDFUND_SUCCESS:
      return {
        ...state,
        livecrowdfund: action.payload,
        livecrowdfundloading: false,
      };
    case crowdsaleActionTypes.LIVE_CROWDSALE_START:
      return {
        ...state,
        livecrowdsaleloading: true,
      };
    case crowdsaleActionTypes.LIVE_CROWDSALE_SUCCESS:
      return {
        ...state,
        livecrowdsale: action.payload,
        livecrowdsaleloading: false,
      };
    case crowdsaleActionTypes.SUCCESSFUL_CROWDSALE_START:
      return {
        ...state,
        successfulcrowdsaleloading: true,
      };
    case crowdsaleActionTypes.SUCCESSFUL_CROWDSALE_SUCCESS:
      return {
        ...state,
        successfulcrowdsale: action.payload,
        successfulcrowdsaleloading: false,
      };
    case crowdsaleActionTypes.FINALIZED_CROWDSALE_START:
      return {
        ...state,
        finalizedcrowdsaleloading: true,
      };
    case crowdsaleActionTypes.FINALIZED_CROWDSALE_SUCCESS:
      return {
        ...state,
        finalizedcrowdsale: action.payload,
        finalizedcrowdsaleloading: false,
      };
    case crowdsaleActionTypes.FINALIZED_CROWDFUND_SUCCESS:
      return {
        ...state,
        finalizedcrowdfund: action.payload,
      };
    case crowdsaleActionTypes.RECENT_CROWDSALE_START:
      return {
        ...state,
        recentcrowdsaleloading: true,
      };
    case crowdsaleActionTypes.RECENT_CROWDSALE_SUCCESS:
      return {
        ...state,
        recentcrowdsale: action.payload,
        recentcrowdsaleloading: false,
      };
    case crowdsaleActionTypes.GET_LIVE_PRICE_SUCCESS:
      return {
        ...state,
        liveprice: action.payload,
      };
    case crowdsaleActionTypes.INVEST_CROWDSALE_START:
      return {
        ...state,
        cartdata: action.payload,
        investloading: true,
      };
    case crowdsaleActionTypes.INVEST_CROWDSALE_SUCCESS: {
      const crowdsaleId = action.payload?.crowdsaleId;
      const xlmIncrement = toFiniteNumber(
        action.payload?.xlmAmount ?? action.payload?.amount
      );
      const xlmPrice = toFiniteNumber(
        state.liveprice?.data?.xlmPrice ?? state.liveprice?.data?.xlm_price
      );
      const usdIncrement = toFiniteNumber(
        action.payload?.usdAmount ??
          (xlmIncrement > 0 && xlmPrice > 0 ? xlmIncrement * xlmPrice : 0)
      );

      return {
        ...state,
        popularcrowdsale: applyInvestmentToCollection(
          state.popularcrowdsale,
          crowdsaleId,
          xlmIncrement,
          usdIncrement
        ),
        recommendcrowdsale: applyInvestmentToCollection(
          state.recommendcrowdsale,
          crowdsaleId,
          xlmIncrement,
          usdIncrement
        ),
        livecrowdsale: applyInvestmentToCollection(
          state.livecrowdsale,
          crowdsaleId,
          xlmIncrement,
          usdIncrement
        ),
        livecrowdfund: applyInvestmentToCollection(
          state.livecrowdfund,
          crowdsaleId,
          xlmIncrement,
          usdIncrement
        ),
        successfulcrowdsale: applyInvestmentToCollection(
          state.successfulcrowdsale,
          crowdsaleId,
          xlmIncrement,
          usdIncrement
        ),
        finalizedcrowdsale: applyInvestmentToCollection(
          state.finalizedcrowdsale,
          crowdsaleId,
          xlmIncrement,
          usdIncrement
        ),
        finalizedcrowdfund: applyInvestmentToCollection(
          state.finalizedcrowdfund,
          crowdsaleId,
          xlmIncrement,
          usdIncrement
        ),
        recentcrowdsale: applyInvestmentToCollection(
          state.recentcrowdsale,
          crowdsaleId,
          xlmIncrement,
          usdIncrement
        ),
        investloading: false,
      };
    }
    case crowdsaleActionTypes.POPULAR_CROWDSALE_FAILURE:
    case crowdsaleActionTypes.RECOMMEND_CROWDSALE_FAILURE:
    case crowdsaleActionTypes.LIVE_CROWDSALE_FAILURE:
    case crowdsaleActionTypes.LIVE_CROWDFUND_FAILURE:
    case crowdsaleActionTypes.GET_LIVE_PRICE_FAILURE:
    case crowdsaleActionTypes.SUCCESSFUL_CROWDSALE_FAILURE:
    case crowdsaleActionTypes.INVEST_CROWDSALE_FAILURE:
    case crowdsaleActionTypes.FINALIZED_CROWDSALE_FAILURE:
    case crowdsaleActionTypes.RECENT_CROWDSALE_FAILURE:
      return {
        ...state,
        ...(action.type === crowdsaleActionTypes.POPULAR_CROWDSALE_FAILURE
          ? { popularcrowdsaleError: true }
          : {}),
        ...(action.type === crowdsaleActionTypes.RECOMMEND_CROWDSALE_FAILURE
          ? { recommendcrowdsaleError: true }
          : {}),
        ...(action.type === crowdsaleActionTypes.LIVE_CROWDFUND_FAILURE
          ? { livecrowdfundError: true }
          : {}),
        popularcrowdsaleloading: false,
        recommendcrowdsaleloading: false,
        recentcrowdsaleloading: false,
        livecrowdsaleloading: false,
        livecrowdfundloading: false,
        successfulcrowdsaleloading: false,
        finalizedcrowdsaleloading: false,
        investloading: false,
      };

    default:
      return { ...state };
  }
};
